import axios from "axios";
import React, { useEffect, useState } from "react";
import { Typography, Checkbox, Row, Button, Col, Skeleton, Card } from "antd";
import TinyDivider from "components/TinyDivider/TinyDivider";
import { Sector } from "./interface";

const { Title, Text } = Typography;

interface Props {
  toggleCheckedSectors: (id: number) => void;
  sectorsChecked: number[];
  onFilterReset: () => void;
}

const EventFilter: React.FC<Props> = ({ toggleCheckedSectors, sectorsChecked, onFilterReset }) => {
  const [sectors, setSectors] = useState<Sector[]>([]);

  useEffect(() => {
    axios.get<Sector[]>("/companies/sectors/").then(response => {
      setSectors(response.data);
    });
  }, []);

  const AxiosSectors = sectors.map(sector => {
    if (!sector.name) return null;
    const isChecked = sectorsChecked.includes(sector.id);
    return (
      <Col xs={12} sm={6} md={24} key={sector.id}>
        <Checkbox checked={isChecked} onChange={() => toggleCheckedSectors(sector.id)} value={isChecked}>
          <Text>{sector.name}</Text>
        </Checkbox>
      </Col>
    );
  });
  return (
    <>
      <Card bodyStyle={{ padding: "2em" }}>
        <Row>
          <Title level={4}>Bransje</Title>
          <TinyDivider
            width="100%"
            style={{
              borderStyle: "solid",
              borderWidth: "1px",
            }}
          />
        </Row>
        <Row>{sectors.length ? AxiosSectors : <Skeleton active />}</Row>
        <Row style={{ paddingTop: "2em" }} justify="center">
          <Button danger block onClick={onFilterReset}>
            Nullstill filtrering
          </Button>
        </Row>
      </Card>
    </>
  );
};

export default EventFilter;
